import z from 'zod'
import {
  nameSchema,
  specialtyIndustrySchema,
  specialtySchema,
  postCodeSchema,
  addressSchema,
  homePhoneSchema,
  homepageSchema,
  establishmentSchema,
  invoiceSchema,
  salesValueSchema,
  properValueSchema,
  bpValueSchema,
  deliverAddressSchema,
  dispatchLicenseSchema,
  dispatchLicenseNumberSchema,
  pMarkSchema,
  ismsSchema,
  memoSchema,
  frequencyCodeSchema,
  tagCodeSchema,
  focusCustomerSchema
} from './CompanySchema'
import {
  cellPhoneSchema,
  departmentSchema,
  fullNameSchema,
  mailSchema,
  postSchema
} from 'schema/sales/SalesSchema'

export type CompanyCreateSchemaType = z.infer<typeof CompanyCreateSchema>
export const CompanyCreateSchema = z.object({
  name: nameSchema.refine((val) => val !== '', { message: '必須項目です' }),
  specialty: z.union([z.literal(''), specialtySchema]),
  specialtyIndustry: z.union([z.literal(''), specialtyIndustrySchema]),
  postCode: z.union([z.literal(''), postCodeSchema]),
  address: z.union([z.literal(''), addressSchema]),
  homePhone: z.union([z.literal(''), homePhoneSchema]),
  homepage: z.union([z.literal(''), homepageSchema]),
  establishment: z.union([z.literal(''), establishmentSchema]),
  invoice: z.union([z.literal(''), invoiceSchema]),
  salesValue: salesValueSchema.optional(),
  properValue: properValueSchema.optional(),
  bpValue: bpValueSchema.optional(),
  deliverAddress: z.union([z.literal(''), deliverAddressSchema]),
  dispatchLicense: dispatchLicenseSchema,
  dispatchLicenseNumber: z.union([z.literal(''), dispatchLicenseNumberSchema]),
  pMark: pMarkSchema,
  isms: ismsSchema,
  memo: z.union([z.literal(''), memoSchema]),
  frequencyCode: frequencyCodeSchema,
  tagCode: tagCodeSchema,
  focusCustomer: focusCustomerSchema,
  sales: z
    .array(
      z.object({
        fullName: fullNameSchema.refine(
          (val) => val !== null && val !== undefined && val !== '',
          { message: '必須項目です' }
        ),
        department: z.union([z.literal(''), departmentSchema]),
        cellPhone: z.union([z.literal(''), cellPhoneSchema]),
        post: z.union([z.literal(''), postSchema]),
        mail: mailSchema
      })
    )
    .min(1, { message: '営業を1名以上登録してください' })
})
